import Promise from 'bluebird';

export default class Animation {
  constructor($element, options = {}) {
    this.$element = $element;
    this.operations = [];
    this.options = options;
  }

  toggleClass(classes) {
    this.operations.push(getStepFunction(this.$element, 'toggleClass', classes));
    return this;
  }

  removeClass(classes) {
    this.operations.push(getStepFunction(this.$element, 'removeClass', classes));
    return this;
  }

  addClass(classes) {
    this.operations.push(getStepFunction(this.$element, 'addClass', classes));
    return this;
  }

  attr(attribute, value) {
    this.operations.push(getStepFunction(this.$element, 'attr', attribute, value));
    return this;
  }

  fadeIn(delay) {
    this.operations.push(getStepFunction(this.$element, 'fadeIn', delay));
    return this;
  }

  delay(milliseconds) {
    this.operations.push({ delay: milliseconds });
    return this;
  }

  keyboardType(value, attribute = 'text', delay = 100) {
    const textParts = textToArray(value);
    textParts.forEach((part, idx) => this.attr(attribute, part).delay(idx > 0 ? delay : delay * 2));
    return this;
  }

  run(force) {
    const dataField = 'data-animation-running';
    const isAnimationRunning = () => this.$element.attr(dataField) === 'true';
    const isAnimationOneShot = () => this.$element.attr(dataField) === 'one-shot';
    const setAnimationRunning = () => this.$element.attr(dataField, 'true');
    const resetAnimationRunning = () =>
      this.$element.attr(dataField, this.options.oneShot ? 'one-shot' : null);

    if (!force && (isAnimationRunning() || isAnimationOneShot())) {
      return Promise.resolve({ message: 'Animation already running' });
    }

    let promise = Promise.resolve().then(() => setAnimationRunning());
    this.operations.forEach(op => {
      return (promise = op.delay ? promise.delay(op.delay) : promise.then(op));
    });
    return promise.finally(() => resetAnimationRunning());
  }
}

function getStepFunction($element, operation, ...params) {
  return () => $element[operation](...params);
}

function textToArray(value) {
  const length = value.length;
  const result = [];

  for (let i = 1; i <= length; i += 1) {
    result[i] = value.substring(0, i);
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/modules/animation-timeline/client.js